interface NavigationItem {
  name: string;
  href: string;
}

export default function Footer({
  footerNavigation,
}: {
  footerNavigation: {
    app: NavigationItem[];
    company: NavigationItem[];
  };
}) {
  return (
    <div className="mx-auto mt-6 max-w-7xl px-6 lg:px-8 dark:bg-boxdark-2">
      <footer
        aria-labelledby="footer-heading"
        className="relative border-t border-neutral-900/10 dark:border-neutral-200/10 py-24 sm:mt-32"
      >
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="flex items-start justify-end mt-10 gap-20">
          <div>
            <h3 className="text-sm font-semibold leading-6 text-neutral-900 dark:text-white">
              App
            </h3>
            <ul role="list" className="mt-6 space-y-4">
              {footerNavigation.app.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm leading-6 text-neutral-600 hover:text-neutral-900 dark:text-white"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold leading-6 text-neutral-900 dark:text-white">
              Company
            </h3>
            <ul role="list" className="mt-6 space-y-4">
              {footerNavigation.company.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm leading-6 text-neutral-600 hover:text-neutral-900 dark:text-white"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
